import { ReactElement } from 'react';
import { ReactComponent as LoaderLogo } from 'src/assets/LoaderLogo.svg';

const LoaderPageV2 = (): ReactElement => {
  return (
    <div className="flex justify-center items-center w-full min-h-screen bg-primehome bg-opacity-80">
      <div className="flex justify-center items-center animate-pulse ">
        <LoaderLogo />
      </div>
    </div>
  );
};
export default LoaderPageV2;
